import { q } from './helper/q'
import { Ias } from './product/ias'
import { sliderInit } from './product/slider'
import { productMenuInit } from './product/scroll'

document.addEventListener('DOMContentLoaded', () => {
  if (q('.oborudovanie')) {
    sliderInit()
    productMenuInit()
  }
  const containers = q('.productsCards')
  if (containers) {
    const ias = new Ias(containers)
    ias.init()
  }
})
